import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Page = (props) => {
  const param = useParams();
  const id = Object.values(param)[0];
  const slug = id
    ? id.length > 10
      ? `${id.slice(0, 4)}...${id.slice(-4)}`
      : id
    : '';
  useEffect(() => {
    // document.title = props.title ? `${props.title} ${slug}` : null;
  }, [props.title]);
  return props.children;
};

export default Page;
